import actions from "../../reducers/registrationForm/registrationFormActions";
import React, {Component} from "react";
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel,
    MenuItem, Select
} from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles';
import {withTranslation} from "react-i18next";
import AddDialogPlayer from "./AddDialogPlayer";
import {connect} from "react-redux";

const styles = (theme) => ({
    errorMessage: {
        color: theme.palette.error.main
    }
});


class AddEntryDialog extends Component {
    state = {
        errorMessage: null
    };

    closeHandler = () => {
        this.props.closeDialog();
    };

    handleCategorySelect = (event) => {
        if (event.target.value !== this.props.selectedCategoryId) {
            const selectedCategory = this.props.categories.find(c => c.id === event.target.value);
            this.props.selectCategory(selectedCategory);
        }
    };

    handlePlayerChange = (event, playerIdx, propertyName) => {
        this.props.updatePlayerProperty(playerIdx, propertyName, event.target.value);
    };

    handleBlur = (event, playerIdx, propertyName) => {
        this.props.fixPlayerNameCase(playerIdx, propertyName);
    }

    handlePlayerCheckbox = (event, playerIdx, param) => {
        const value = param.type === 'BOOL' ? event.target.checked : event.target.value;
        this.props.updatePlayerParam(playerIdx, param.name, value);
    };

    handleAddButtonClick = () => {
        console.log("Clicked on Add!");
        // validate that puppy
        let errorFound = false;
        const errors = {};
        this.props.entry.players.forEach((player, idx) => {
            const textFields = ['firstName', 'lastName'];
            textFields.forEach(fieldName => {
                const val = player[fieldName];
                if (!val) {
                    errorFound = true;
                    errors['playerError' + idx + fieldName] = true;
                } else {
                    errors['playerError' + idx + fieldName] = false;
                }
            });
        });

        if (errorFound) {
            errors.errorMessage = 'Please correct the errors in the form';
            this.setState(errors);
        } else {
            errors.errorMessage = null;
            this.setState(errors);

            // TODO - handle case when we're editing an entry that already exists
            // const entry = {
            //     eventCategoryId: this.state.selectedCategoryId,
            //     eventCategoryName: this.state.selectedCategory.name,
            //     players: this.state.players,
            //     tempId: uuidv4(),
            //     deleted: false
            // };
            // const players = createPlayers(this.state.selectedCategory, this.props.defaultCountry);
            // and send back to the registration form
            this.props.addEntryHandler(this.props.entry);
        }
    };

    createEntry = (player, playerIdx) => {
        const lastNameError = this.state['playerError' + playerIdx + 'lastName'];
        const firstNameError = this.state['playerError' + playerIdx + 'firstName'];
        const {t} = this.props;
        return (
            <AddDialogPlayer
                key={'pl-' + playerIdx}
                handlePlayerChange={this.handlePlayerChange}
                handlePlayerCheckbox={this.handlePlayerCheckbox}
                handleBlur={this.handleBlur}
                gender={player.gender}
                playerIdx={playerIdx}
                lastName={player.lastName}
                lastNameError={lastNameError}
                firstName={player.firstName}
                firstNameError={firstNameError}
                country={player.country}
                category={this.props.selectedCategory}
                params={player.params}
                t={t} />
        );
    };

    render() {
        const {categories, classes, open, t, selectedCategory, selectedCategoryId} = this.props;

        const categoryOptions = categories.map((c) => {
            return <MenuItem key={"cat" + c.id} value={c.id}>{c.name}</MenuItem>
        });

        let entryFields = [];
        if (selectedCategory) {
            if (this.props.entry && this.props.entry.players) {
                entryFields = this.props.entry.players.map((player, idx) => {
                    return this.createEntry(player, idx);
                });
            }
        }

        const errorText = this.state.errorMessage ? <DialogContentText className={classes.errorMessage}>{t('registrationForm.dialog.correctErrors')}</DialogContentText> : null;
        let addButtonText = this.props.mode === actions.ADD_DIALOG_MODE.ADD_NEW ? t('registrationForm.dialog.addButton') : t('registrationForm.dialog.updateButton');
        const categoryReadOnly = this.props.mode !== actions.ADD_DIALOG_MODE.ADD_NEW;

        return (
            <Dialog open={open} onClose={() => this.closeHandler()} aria-labelledby="add-entry-dialog-title">
                <DialogTitle id="add-entry-dialog-title">{t('registrationForm.dialog.addPlayerTitle')}</DialogTitle>
                <DialogContent>
                    {errorText}
                    <FormControl fullWidth={true}>
                        <InputLabel shrink id="category-select-label">{t('registrationForm.dialog.category')}</InputLabel>
                        <Select
                            labelId="category-select-label"
                            id="category-select"
                            readOnly={categoryReadOnly}
                            onChange={(e) => this.handleCategorySelect(e)}
                            value={selectedCategoryId}>
                            {categoryOptions}
                        </Select>
                    </FormControl>
                    {entryFields}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.props.closeDialog()} color="primary" size="small" variant="outlined">{t('registrationForm.dialog.closeButton')}</Button>
                    <Button onClick={() => this.handleAddButtonClick()} color="primary" size="small" variant="contained">{addButtonText}</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedCategory: state.regForm.addDialogSelectedCategory,
        selectedCategoryId: state.regForm.addDialogSelectedCategoryId,
        entry: state.regForm.addDialogEntry,
        open: state.regForm.addDialogOpen,
        mode: state.regForm.addDialogMode
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectCategory: (category) => dispatch({type: actions.ADD_DIALOG_SELECT_CATEGORY, category: category}),
        updatePlayerProperty: (playerIndex, propertyName, value) => dispatch({type: actions.ADD_DIALOG_UPDATE_PLAYER, playerIndex, propertyName, value}),
        updatePlayerParam: (playerIndex, paramName, value) => dispatch({type: actions.ADD_DIALOG_UPDATE_PLAYER_PARAM, playerIndex, paramName, value}),
        closeDialog: () => dispatch({type: actions.ADD_DIALOG_OPEN, open: false}),
        fixPlayerNameCase: (playerIndex, propertyName) => dispatch({type: actions.ADD_DIALOG_FIX_NAME_CASE, playerIndex, propertyName})
    };
};

export default withStyles(styles)(withTranslation('messages')(connect(mapStateToProps, mapDispatchToProps)(AddEntryDialog)));